import React, { useState } from 'react';
import './Home.css';

// Import homepage sections
import HeroVideo from '../../components/Home/HeroVideo';
import PromotionSection from '../../components/Home/PromotionSection/';
import VideoWithText from '../../components/Home/VideoWithText';
import TeamGallery from '../../components/Home/TeamGallery';
import YouTubeVideo from '../../components/Home/YouTubeVideo';
import ShopPromotion from '../../components/Home/ShopPromotion';
import ClubPromotion1 from '../../components/Home/ClubPromotion1';
import ClubPromotion2 from '../../components/Home/ClubPromotion2';
import NewsSection from '../../components/Home/NewsSection';

const Home = () => {
  const handleAnimationComplete = () => {
    // Animation complete - no header to show
  };

  return (
    <div className="home-page">
      {/* Section 1: Hero Video with Animation */}
      <HeroVideo onAnimationComplete={handleAnimationComplete} />
      
      {/* Section 2: Promotion Advertisement */}
      <PromotionSection />
      
      {/* Section 3: Video with Title and Text */}
      <VideoWithText />
      
      {/* Section 4: Team Gallery */}
      <TeamGallery />
      
      {/* Section 5: YouTube Video with Image and Text */}
      <YouTubeVideo />
      
      {/* Section 6: Shop Promotion */}
      <ShopPromotion />
      
      {/* Section 7: Club Promotion 1 */}
      {/* <ClubPromotion1 /> */}
      
      {/* Section 8: Club Promotion 2 */}
      <ClubPromotion2 />
      
      {/* Section 9: News Section */}
      {/* <NewsSection /> */}
    </div>
  );
};

export default Home;
